import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NewsPanel from "../components/Common/news-panel";
import DesktopBanner from "../assets/news/news-desktop.jpg";
import MobileBanner from "../assets/news/news-mobile.jpg";
import newsData from "../data/news-data";

const News = () => {
  useEffect(() => {AOS.init({ duration: 1000, easing: "ease-in-out", once: true });}, []);
  const [activeNews, setActiveNews] = useState(null);
  const openPanel = (newsItem) => {setActiveNews(newsItem === activeNews ? null : newsItem);};

  return (
    <div className="w-full">
      {/* Desktop Banner */}
      <div className="w-full" data-aos="fade-down">
      <img className="hidden md:flex w-full aspect-[1/0.35]" src={DesktopBanner} alt="News Banner" /></div>

      {/* Mobile Banner */}
      <div className="md:hidden w-full px-0 overflow-hidden" data-aos="fade-up">
      <img className="w-full shadow-lg transition-transform duration-500 ease-in-out hover:scale-105" src={MobileBanner} alt="News Mobile Banner" /></div>

      {/* News Section */}
      <div className="w-full px-8 pt-8 pb-4 md:px-12 md:pb-8 text-blue font-tenor" data-aos="fade-up">
      <p className="text-2xl uppercase mb-2 font-bold">News and Updates</p>
      <p className="text-sm md:text-base">Stay tuned for our latest projects, partnerships, and achievements as we continue to shape the future of education.</p></div>
      
      {/* News Items */}
      <div className="grid grid-cols-1 md:grid-cols-2 w-full px-8 md:px-12 font-tenor gap-8 pb-8">
  {newsData.slice().reverse().map((newsItem, index) => (
    <div key={index} data-aos="zoom-in" className="p-4 shadow-md md:shadow-lg">
      <p className="mb-2 text-xs underline text-gray-800">{newsItem.date}</p>
      <p className="mb-2 font-bold text-sm">{newsItem.title}</p>
      <div className="overflow-hidden mb-2">
<img
  className="transition-transform duration-500 ease-in-out hover:scale-105"
  src={Array.isArray(newsItem.img) ? newsItem.img[0] : newsItem.img}
  alt=""
/>
      </div>
      <button
        className={`md:w-auto text-sm w-full py-2 px-4 rounded-md font-semibold transition duration-200 uppercase ${
          activeNews === newsItem ? "bg-blue text-white" : "bg-yellow text-blue hover:bg-blue hover:text-white"
        }`}
        onClick={() => openPanel(newsItem)}
      >
        Read More
      </button>
    </div>
  ))}
</div>


      {/* NewsPanel Component */}
      <NewsPanel date={activeNews?.date} title={activeNews?.title} img={activeNews?.img} text={activeNews?.text} isOpen={activeNews !== null} onClose={() => setActiveNews(null)}/></div>);};

export default News;
